module.exports = __webpack_public_path__ + "static/media/planet-moon.57e1b8c5.svg";